import { Button, Group, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import Tip from 'src/components/design-system/Tip';
import { ExampleStack, type Example } from '../';

function basicUsage(): Example {
  return {
    description: 'Basic tooltip on a button',
    render: (
      <Tip label="This is a tip">
        <Button>Hover me</Button>
      </Tip>
    ),
  };
}

function onIcon(): Example {
  return {
    description: 'Tooltip on an icon for contextual help',
    render: (
      <Group>
        <Text>What is this?</Text>
        <Tip label="Helpful information about this feature">
          <IconInfoCircle size={18} style={{ cursor: 'help' }} />
        </Tip>
      </Group>
    ),
  };
}

function positions(): Example {
  return {
    description: 'Different tooltip positions',
    render: (
      <Group>
        <Tip label="Top" position="top">
          <Button variant="outline">Top</Button>
        </Tip>
        <Tip label="Bottom" position="bottom">
          <Button variant="outline">Bottom</Button>
        </Tip>
        <Tip label="Left" position="left">
          <Button variant="outline">Left</Button>
        </Tip>
        <Tip label="Right" position="right">
          <Button variant="outline">Right</Button>
        </Tip>
      </Group>
    ),
  };
}

function multiline(): Example {
  return {
    description: 'Multiline tooltip with longer content',
    render: (
      <Tip
        label="This is a longer tooltip that demonstrates how the Tip component handles multi-line content"
        multiline
        w={200}
      >
        <Button>Hover for details</Button>
      </Tip>
    ),
  };
}

export default function TipSandbox() {
  return <ExampleStack examples={[basicUsage(), onIcon(), positions(), multiline()]} />;
}
